import { v4 as uuidv4 } from 'uuid';

import { Login } from '../../../../vtex-apps/login/Login/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { FlexLayoutRow, FlexLayoutCol } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { SearchBar } from '../../../../vtex-apps/store-components/SearchBar/default';
import { Logo } from '../../../../vtex-apps/store-components/Logo/default';
import { StickyLayout } from '../../../../vtex-apps/sticky-layout/StickyLayout/default';
import { OverlayTrigger } from '../../../../vtex-apps/overlay-layout/overlayTriggerDefault';
import { OverlayLayout } from '../../../../vtex-apps/overlay-layout/overlayLayoutDefault';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

const HeaderDesktop = () => {
	return {
		componentName: 'HeaderDesktop',
		componentId: uuidv4(),
		componentGroup: 'HeaderDesktop',
		variables,
		props: {
			mzTitle: 'MZ | Header - Desktop',
			blockClass: 'mz-header-1',
		},
		childrenComponents: [
			FlexLayoutRow({ blockClass: 'mz-header-1-top', horizontalAlign: 'between', colSizing: 'auto' }, [
				FlexLayoutCol({ blockClass: 'header-desk-1__flex-col-top' }, [
					RichText({
						text: 'Há 26 anos oferecendo materiais médico-hospitalares de qualidade em todo Brasil',
						blockClass: 'mz-header-1-top-text',
					}),
					OverlayTrigger({ blockClass: 'overlay-trigger__header-1' }, [
						RichText({ blockClass: 'overlay-rich-text__header-1', text: 'Central de Atendimento' }),
						OverlayLayout({ blockClass: 'overlay-layout__header-1' }, [
							FlexLayoutRow({ blockClass: 'overlayout-item-row__header-1', colSizing: 'auto' }, [
								RichText({
									blockClass: 'overlay-item__header-1',
									text: '[Fale com a gente pelo WhatsApp]()',
								}),
								RichText({
									blockClass: 'overlay-item__header-1',
									text: '[Envie seu contato para a gente]()',
								}),
								RichText({
									blockClass: 'overlay-item__header-1',
									text: 'Atendimento: de Segunda a Sexta-feira das 09:00 as 18:00 e Sábado das 08:00 as 13:00',
								}),
							]),
						]),
					]),
				]),
			]),
			StickyLayout({ blockClass: 'header-desktop-1-sticky', position: 'top', verticalSpacing: 0 }, [
				FlexLayoutRow(
					{
						colSizing: 'auto',
						fullWidth: false,
						horizontalAlign: 'between',
						blockClass: 'mz-header-1-row-1',
					},
					[
						FlexLayoutCol({ width: { desktop: 'grow', mobile: 'grow' } }, [
							Logo({
								width: 300,
								url: 'https://maeztra.com/wp-content/uploads/2020/09/logo_Prancheta-1.svg',
								href: '/',
								title: 'Logo',
								blockClass: 'mz-header-1',
							}),
						]),
						FlexLayoutCol({ width: { desktop: '50%', mobile: '50%' }, blockClass: 'header-desk-1__col-search' }, [
							SearchBar({
								placeholder: 'O que você procura?',
								inputType: 'text',
								maxWidth: '517px',
								blockClass: 'mz-header-1',
							}),
						]),
						FlexLayoutCol({ width: { desktop: 'grow', mobile: 'grow' } }, [
							FlexLayoutRow({ colSizing: 'auto', colGap: { desktop: 3 }, blockClass: 'header-desk-1__row-icons' }, [
								Login({ iconLabel: 'Minha Conta', blockClass: 'mz-header-1' }),
								RichText({ text: '[Favoritos](/wishlist)', blockClass: 'mz-favorites' }),
								{
									componentGroup: 'MinicartGroup',
									componentName: 'MinicartGroup',
									componentId: uuidv4(),
								},
							]),
						]),
					],
				),
				{
					componentGroup: 'StoreMenuDesktop',
					componentName: 'FlexLayoutRow',
					componentId: uuidv4(),
				},
			]),

			// VisibilityLayout({visible:true,mzTitle:"MZ | Modal de cookies (On/Off)"},[{componentName:"CookieModal"}]),
			VisibilityLayout({ mzTitle: 'MZ | Botão Whatsapp (On/Off)' }, [
				FlexLayoutRow({ blockClass: 'mz-header-1-whats-float__flex-row' }, [
					Image({
						blockClass: 'mz-header-1-whatsapp-float-1__image',
						src: 'https://hefesto-upload-images.s3.amazonaws.com/1682006713447-1681501967650-WhatsApp.png',
					}),
					RichText({
						blockClass: 'mz-header-1-whatsapp-float-1__text',
						text: '[Atendimento](https://whts.co/)',
					}),
				]),
			]),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--top-header-1-text-color', name: 'Top Header Text' },
			{ from: '--white', to: '--top-header-1-link-color', name: 'Top Header Link' },
			{ from: '--brand-color-primary-pure', to: '--top-header-1-bg-color', name: 'Top Header Background' },
			{ from: '--cta-color-pure', to: '--top-header-1--link-bg-color', name: 'Top Header Link Background' },
			{ from: '--white', to: '--header-desktop-1-bg-color', name: 'Header Background' },
			// { from: "--white", to: "--header-desktop-1-menu-bg-color", name: "Menu Background", },
			{ from: '--text-color-1-dark', to: '--header-desktop-1-text-color', name: 'Icons Text' },
			// { from: "--text-color-1-dark", to: "--header-desktop-1-menu-text-color", name: "Menu Text", },
			{ from: '--text-color-1-dark', to: '--header-desktop-1-search-border-color', name: 'Search Border' },
			{ from: '--text-color-1-dark', to: '--header-desktop-1-search-button-color', name: 'Search Button' },
			{ from: '--white', to: '--header-desktop-1-search-icon-color', name: 'Search Icon' },
			{ from: '--transparent', to: '--header-desktop-1-search-background-color', name: 'Search Background' },
			{
				from: '--text-color-1-dark',
				to: '--header-desktop-1-categories-border-color',
				name: 'All Categories Border',
			},
			{ from: '--text-color-1', to: '--header-desktop-1-cda-text', name: 'Central de Atendimento Text' },
			//submenu text color
			// { from: "--text-color-1-dark", to: "--header-desktop-1-submenu-text-color", name: "Submenu Text", },
			//submenu
			// { from: "--white", to: "--header-desktop-1-submenu-bg-color", name: "Submenu", },
			//submenu border color
			// { from: "--text-color-1-dark", to: "--header-desktop-1-submenu-border-color", name: "Submenu Border", },
			//submenu item hover
			// { from: "--neutral-color-high-medium", to: "--header-desktop-1-submenu-item-hover-color", name: "Submenu Item Hover", },
			//minicart color
			{ from: '--support-color-3', to: '--header-desk-1-minicart-color', name: 'Minicart' },
			{ from: '--white', to: '--header-desk-1-minicart-text', name: 'Minicart Text' },

			{ from: '--support-color-3', to: '--header-desktop-1-whatsapp-bg-color', name: 'Whatsapp Background' },
			{
				from: '--support-color-3',
				to: '--header-desktop-1-whatsapp-bg-hover',
				name: 'Whatsapp Background Hover',
			},
			//search autocomplete
			{
				from: '--neutral-color-low-medium',
				to: '--header-desktop-1-search-autocomplete-text-color',
				name: 'Search Autocomplete Text',
			},
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-none', to: '--header-desktop-1-border-radius', name: 'Border Radius' },
			// { from: "--border-radius-sm", to: "--header-desktop-1-submenu-br", name: "Submenu", },
			//login border radius
			{ from: '--border-radius-sm', to: '--header-desk-1-login-br', name: 'Login' },
			//whatsapp border radius
			{ from: '--border-radius-sm', to: '--header-desktop-1-whatsapp-br', name: 'Whatsapp' },
			//search autocomplete
			{
				from: '--border-radius-sm',
				to: '--header-desktop-1-search-autocomplete-br',
				name: 'Search Autocomplete',
			},
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-sm', to: '--top-header-1-text-size', name: 'Top Header Text Size' },
			{ from: '--font-size-sm', to: '--top-header-1-link-size', name: 'Top Header Link Size' },
			{ from: '--font-size-xs', to: '--header-desktop-1-main-size', name: 'Icons Size' },
			{ from: '--font-size-xs', to: '--header-desktop-1-cda-text-fs', name: 'Central de Atendimento' },
			//submenu text size
			// { from: "--font-size-xs", to: "--header-desktop-1-submenu-fs", name: "Submenu", },
			//search autocomplete
			{ from: '--font-size-xs', to: '--header-desktop-1-search-autocomplete-fs', name: 'Search Autocomplete' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--header-desktop-1-main-weight', name: 'Main font weight' },
			// { from: "--font-weight-400", to: "--header-desktop-1-menu-weight", name: "Menu font weight", },
			//submenu
			// { from: "--font-weight-400", to: "--header-desktop-1-submenu-fw", name: "Submenu", },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-nano', to: '--header-desktop-1-topbar-spacing', name: 'Topbar size' },
			{ from: '--spacing-atom', to: '--header-desktop-1-submenu-gap', name: 'Submenu Items Gap' },
			//submenu lateral padding
			{ from: '--spacing-sm', to: '--header-desktop-1-submenu-lateral-padding', name: 'Submenu Lateral Padding' },
		],
	},
];

export default HeaderDesktop;
